import * as React from 'react'
import { LinkMenuProps } from './types'
import {
  MenuBox,
  MenuDescription,
  MenuLegend,
  MenuItemList,
  MenuItem
} from './styles'

export const LinkMenu = ({
  description,
  legend,
  items,
  position,
  badgeHeight,
  badgeMargin,
  menuCloseCallback,
  ...theme
}: LinkMenuProps) => {
  return (
    <MenuBox {...{ position, badgeHeight, badgeMargin, ...theme }}>
      <MenuDescription {...theme}>{description}</MenuDescription>
      <MenuLegend {...theme}>{legend}</MenuLegend>
      <MenuItemList {...theme} position={position}>
        {items.map(
          ({ text, link: { href, target, alt: ariaLabel } }, index) => (
            <MenuItem
              {...theme}
              href={href}
              target={target}
              role='link'
              key={index}
              aria-label={ariaLabel}
              // eslint-disable-next-line @typescript-eslint/no-unused-vars
              onClick={(_) => menuCloseCallback()}
            >
              <div>
                <span>{text}</span>
                <svg>
                  <line x1='9' y1='6' x2='15' y2='12' />
                  <line x1='9' y1='18' x2='15' y2='12' />
                </svg>
              </div>
            </MenuItem>
          )
        )}
      </MenuItemList>
    </MenuBox>
  )
}
